import config from 'appConfig';

const BASE_URL = `${config.featureFlags.url}/v1/api/frontend`;

export const getFeatureFlags = async (context) => {
  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: config.featureFlags.clientKey
    },
    body: JSON.stringify({
      accountKey: String(context.accountKey || ''),
      userId: String(context.userKey || ''),
      email: String(context.email || ''),
      channel: String(context.channel || ''),
      seats: String(context.seats || ''),
      serviceType: String(context.serviceType || '')
    })
  });

  if (!response.ok) {
    throw new Error(`Feature flags request failed: ${response.status}`);
  }

  return response.json();
};

export default {
  getFeatureFlags
};
